module.exports = __webpack_public_path__ + "static/media/advantage-1.ce6809e3.svg";